'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleWithLine = exports.ChoseEntityLabel = undefined;
var _templateObject = _taggedTemplateLiteral(['\n  align-self: center;\n  color: ', ';\n  margin-bottom: 0.5rem;\n\n  ', '\n'], ['\n  align-self: center;\n  color: ', ';\n  margin-bottom: 0.5rem;\n\n  ', '\n']),
  _templateObject2 = _taggedTemplateLiteral(['\n          margin-top: 2rem;\n        '], ['\n          margin-top: 2rem;\n        ']),
  _templateObject3 = _taggedTemplateLiteral(['\n          margin-top: 1rem;\n        '], ['\n          margin-top: 1rem;\n        ']),
  _templateObject4 = _taggedTemplateLiteral(['\n  margin-top: 1rem;\n\tposition: relative;\n\ttext-align: center;\n\tz-index: 1;\n\tcolor: ', ';\n\n\t&:before {\n\t\tborder-top: 2px solid ', ';\n\t\tcontent: "";\n\t\tmargin: 0 auto;\n\t\tposition: absolute;\n\t\ttop: 50%; left: 0; right: 0; bottom: 0;\n\t\twidth: 100%;\n\t\tz-index: -1;\n\t}\n\n\t& > span {\n\t\tbackground: ', ';\n\t\tpadding: 0 15px;\n\t}\n'], ['\n  margin-top: 1rem;\n\tposition: relative;\n\ttext-align: center;\n\tz-index: 1;\n\tcolor: ', ';\n\n\t&:before {\n\t\tborder-top: 2px solid ', ';\n\t\tcontent: "";\n\t\tmargin: 0 auto;\n\t\tposition: absolute;\n\t\ttop: 50%; left: 0; right: 0; bottom: 0;\n\t\twidth: 100%;\n\t\tz-index: -1;\n\t}\n\n\t& > span {\n\t\tbackground: ', ';\n\t\tpadding: 0 15px;\n\t}\n']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var ChoseEntityLabel = exports.ChoseEntityLabel = _styledComponents2.default.p(_templateObject, function (props) {
  return props.theme[props.color || 'color_white'];
}, function (props) {
  var _props$theme$getMedia = props.theme.getMedias,
    laptops = _props$theme$getMedia.laptops,
    iphones = _props$theme$getMedia.iphones,
    desktops = _props$theme$getMedia.desktops;
  return '\n      ' + laptops()(_templateObject2) + '\n      ' + iphones()(_templateObject3) + '\n      ' + desktops()(_templateObject2) + '\n    ';
});
var TitleWithLine = exports.TitleWithLine = _styledComponents2.default.h3(_templateObject4, function (props) {
  return props.theme.color_light_blue;
}, function (props) {
  return props.theme.color_light_blue;
}, function (props) {
  return props.theme.color_white;
});